import { Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useHomSetupStatus } from "../../hooks/useHomSetupStatus";
import { normalizeUserRole } from "../../utilities/userRoleUtils";
import { isUiAdmin } from "../../utilities/roleCapabilities";

const SETUP_HOME_PATH = "/reports/dashboard";

export function HomSetupGuard({ children, appType }) {
  const location = useLocation();
  const isHomsApp = appType?.startsWith("HOMS");
  const { isLoading, setupComplete } = useHomSetupStatus();
  const userRole = useSelector((state) => state.usersState?.userRole);
  const normalizedRole = normalizeUserRole(userRole);
  // Only Admins are forced onto the setup landing page. Agent/SalesAgent (and others)
  // must not be bounced here if their route set differs — that caused Redirect loops.
  const isAdmin = isUiAdmin(normalizedRole);

  if (!isHomsApp) {
    return children;
  }

  if (
    isAdmin &&
    !setupComplete &&
    !isLoading &&
    location.pathname !== SETUP_HOME_PATH
  ) {
    return <Redirect to={SETUP_HOME_PATH} />;
  }

  return children;
}

export default HomSetupGuard;
